export function defaultsDeep(object: object | Array<any>, ...sources: any[]) {
    return sources.reduce((acc, source) => customDefaultsDeep(acc, source), object);
}

function customDefaultsDeep(object, source) {
    if (Array.isArray(source)) {
        if (object === undefined) {
            object = []
        }

        if (source.length < object.length) {
            return object.map((item, key) => merge(source, object, key, customDefaultsDeep))
        } else {
            return source.map((item, key) => merge(object, source, key, customDefaultsDeep))
        }
    } else {
        if (object === undefined) {
            object = {}
        }

        return Object.keys(source).reduce((acc, key) => {
            acc[key] = merge(object, source, key, customDefaultsDeep);
            return acc
        }, object)
    }
}

function merge(object, source, key, rec) {
    return isPrimitive(source[key])
        ? object[key] === undefined
            ? source[key]
            : object[key]
        : rec(object[key], source[key])
}

function isPrimitive(test) {
    return test !== Object(test)
}
